import { call, put, takeEvery, all, fork } from 'redux-saga/effects';
import { FETCH_VENDORS_BY_REGION, FETCH_VENDORS_BY_REGION_SUCCESS, FETCH_VENDORS_BY_REGION_ERROR } from '../../actions';
import apiCall from '../../../apiCall';
import { customHeaders, adminAPIURL } from '../../../../../Containers/Config';
import { getVendorKey } from '../../../../../Containers/Config';

/* ================= WORKER ================= */
function* fetchVendorsByRegion({ payload }) {
  const { regionId } = payload;
  const key = getVendorKey(regionId);

  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/configuration/region/${regionId}/serviceable-vendors`,
      method: 'GET',
      headers: filteredHeaders,
    });

    yield put({
      type: FETCH_VENDORS_BY_REGION_SUCCESS,
      payload: { key, data: response?.data },
    });
  } catch (error) {
    yield put({
      type: FETCH_VENDORS_BY_REGION_ERROR,
      payload: { key, error },
    });
  }
}

/* ================= WATCHER ================= */
export function* watchfetchVendorsByRegion() {
  yield takeEvery(FETCH_VENDORS_BY_REGION, fetchVendorsByRegion);
}

/* ================= ROOT SAGA (DEFAULT EXPORT) ================= */
function* fetchVendorsByRegionSaga() {
  yield all([fork(watchfetchVendorsByRegion)]);
}

export default fetchVendorsByRegionSaga;
